<template>
  <div>
    <p
      :class="workOrder.elapsed_time > 60 ? 'mt-8' : 'my-8'"
    >
      {{ message }}
    </p>
    <div
      v-if="workOrder.elapsed_time > 60"
      class="flex flex-wrap justify-around items-center mt-6 mb-10 py-2 mx-4 bg-blue-50 rounded"
    >
      <p class="italic w-full sm:w-auto">
        Saving Labor Charge:
      </p>
      <div class="flex flex-col items-start my-2 sm:my-0">
        <p><span class="font-medium">Total Time:</span> {{ totalTime }}</p>
        <p><span class="font-medium">Employee:</span> {{ employeeName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'TakeOverPrompt',
  computed: {
    ...mapState(['headers']),
    ...mapGetters([
      'getCurrentWorkOrder',
      'allSiteEmployees',
      'startingPMSubmission'
    ]),
    workOrder() {
      return Object.values(this.getCurrentWorkOrder)[0]
    },
    workOrderId() {
      return Object.keys(this.getCurrentWorkOrder)[0]
    },
    employeeName() {
      return this.allSiteEmployees[this.workOrder.employee_id]
        ? this.allSiteEmployees[this.workOrder.employee_id]
        : 'Unnamed Employee'
    },
    message() {
      if (this.workOrder.elapsed_time > 60) {
        return `${this.startingPMSubmission ? 'Submitting' : 'Taking over'} this work order will stop ${this.employeeName}'s timer and record their time as a labor charge.`
      }
      else return `${this.startingPMSubmission ? 'Submitting' : 'Taking over'} this work order will stop ${this.employeeName}'s timer.`
    },
    totalTime() {
      let elapsedTime = this.workOrder.elapsed_time
      let seconds = (elapsedTime % 60).toString().padStart(2, '0')
      let minutes = Math.floor(elapsedTime / 60 % 60).toString().padStart(2, '0')
      let hours = Math.floor(elapsedTime / 3600).toString().padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    }
  },
}
</script>